import React from 'react';
import { css } from 'styled-components';
import styled from 'styled-components/macro';

import { Colors } from 'constants/theme';

import { CheckMark } from '../icons/checkMark';

export interface CheckBoxProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  label?: string;
}

interface InputProps {
  checked: boolean;
  error?: string;
}

export const SimpleCheckbox: React.FC<CheckBoxProps> = (props) => {
  const { children, error, ...input } = props;
  const checked = input.checked !== undefined && input.checked !== false;
  return (
    <Wrapper>
      <HiddenInput
        data-testid="checkbox"
        {...input}
        checked={checked}
        type="checkbox"
      />
      <CheckWrapper>
        <Box checked={checked} error={error}>
          {checked ? <CheckMark /> : null}
        </Box>
        <Text>{children}</Text>
      </CheckWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.label`
  cursor: pointer;
  display: flex;
  position: relative;
`;

const CheckWrapper = styled.div`
  display: flex;
`;

const HiddenInput = styled.input`
  height: 1px;
  position: absolute;
  visibility: hidden;
  width: 1px;
`;

const Text = styled.p`
  margin: 0;
  padding: 0;
  color: #333333;
  font-family: 'EuclidCircularB', sans-serif;
  font-size: 16px;
  line-height: 24px;
  a {
    text-decoration: underline;
    color: inherit;
  }
`;

const Box = styled(({ checked, error, ...rest }) => (
  <div {...rest} {...checked} {...error} />
))<InputProps>`
  background: ${(props) => (props.checked ? Colors.sage4 : Colors.grey2)};
  border: 1px solid
    ${(props) => {
      if (props.checked) {
        return Colors.sage4;
      }
      if (props.error) {
        return Colors.poppy6;
      }
      return Colors.grey4;
    }};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
  height: 20px;
  margin-right: 20px;
  min-width: 20px;
  transition: border-color 0.2s linear, background-color 0.2s linear;
  width: 20px;
  label:hover & {
    border-color: ${Colors.sage4};
  }
  label:active & {
    background: ${Colors.sage4};
    border-color: ${Colors.sage4};
    color: ${Colors.sage4};
    transition: none;
  }
  ${(props) => {
    if (props.error) {
      return css`
        background-color: ${Colors.poppy6};
      `;
    }
    return '';
  }}
`;
